import { render, staticRenderFns } from "./shortcut.vue?vue&type=template&id=30a62b27&scoped=true&"
import script from "./shortcut.vue?vue&type=script&lang=js&"
export * from "./shortcut.vue?vue&type=script&lang=js&"
import style0 from "./shortcut.vue?vue&type=style&index=0&id=30a62b27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a62b27",
  null
  
)

export default component.exports